'use client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import { useEffect, useMemo, useState } from 'react';
import Slider from 'react-slick';
import { useMedia } from 'react-use';
import SlickArrowLeft from 'shared/sections/ServiceServices/Arrows/SlickArrowLeft';
import SlickArrowRight from 'shared/sections/ServiceServices/Arrows/SlickArrowRight';
import Service from 'shared/sections/ServiceServices/Service/Service';

import cn from './style.module.sass';

type Service = {
    title: string;
    href: string;
    image: string;
    imageLight: string;
};

type ServicesCorporatePortalsProps = {
    listServicesCorporatePortals: Service[];
};

const ServicesCorporatePortals = ({
    listServicesCorporatePortals,
}: ServicesCorporatePortalsProps) => {
    const isMobile = useMedia('(max-width: 1199px)');

    const [isMount, setIsMount] = useState(false);
    useEffect(() => {
        setIsMount(true);
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
    let slider: unknown;

    const settings = useMemo(
        () => ({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            nextArrow: <SlickArrowRight />,
            prevArrow: <SlickArrowLeft />,
            variableWidth: !isMobile,
        }),
        [isMobile]
    );
    return (
        <ScrollAnimation>
            <FullWrapper smallPaddings={true} isMargin={false} className={cn['about-services']}>
                <div className={cn['services__header']}>Услуги</div>
                <div className={cn['services__container']}>
                    {isMount && (
                        <Slider
                            /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
                            ref={c => (slider = c)}
                            className={cn['services__container-slider']}
                            {...settings}
                        >
                            {listServicesCorporatePortals.map(
                                ({ title, image, href, imageLight }) => {
                                    return (
                                        <Service
                                            key={title}
                                            imageLight={imageLight}
                                            title={title}
                                            image={image}
                                            href={href}
                                        />
                                    );
                                }
                            )}
                        </Slider>
                    )}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default ServicesCorporatePortals;
